import React, { Component } from 'react';

// Actualizado: componente vacío → banda de KPIs (azul marino / dorado)
// Estilos en style.css: .kpi-band, .highlight-number, .kpi-label

class Counter extends Component {
    constructor(props){
        super(props);
        this.state = {
            kpis: [
                {
                    id: 1,
                    number: '+20',
                    label: 'Años en el servicio público'
                },
                {
                    id: 2,
                    // TODO: agregar enlace a fuente oficial del IMCO
                    number: '#7',
                    label: 'Nacional en el Índice IMCO (Pachuca 2016–2020)'
                },
                {
                    id: 3,
                    number: '6+',
                    label: 'Cargos en finanzas públicas municipales'
                },
                {
                    id: 4,
                    // TODO: reemplazar con cifra del presupuesto municipal vigilado
                    number: '2024',
                    label: 'Regidora de Mineral de la Reforma'
                }
            ]
        }
    }

    render() {
        return (
            <section className="kpi-band">
                <div className="container">
                    <div className="row justify-content-center">
                        {
                            this.state.kpis.map((data) => (
                                <div className="col-lg-3 col-md-6 col-sm-6" key={data.id}>
                                    <div className="kpi-item">
                                        <span className="highlight-number">{data.number}</span>
                                        <span className="kpi-label">{data.label}</span>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </section>
        );
    }
}

export default Counter;
